import { FormikProps } from 'formik'
import get from 'lodash/get'

import { Address, ApplianceType, Input, InputAdminStatus, IpPortMode, OccupiedPort } from 'common/api/v1/types'

import { Select } from '../../../../common/Form'
import { createDefaultFiledValues, isCoreNode, makeAddressOptions } from '../../../../../utils'
import { isVaApplianceType } from 'common/applianceTypeUtil'
import { WhitelistCidrBlockAutoComplete } from '../../../../common/WhitelistCidrBlockAutoComplete'
import { SuggestedLocalPortTextField } from '../../../../common/SuggestedPortTextField'

export enum RtmpFields {
  address = 'address',
  port = 'port',
  whitelistCidrBlock = 'whitelistCidrBlock',
}
export const rtmpDefaults = () =>
  createDefaultFiledValues(Object.keys(RtmpFields), [], {
    [RtmpFields.whitelistCidrBlock]: [],
  })

interface RtmpFormProps {
  form: FormikProps<Input>
  addresses: Array<Address>
  namePrefix: string
  occupiedPorts: OccupiedPort[]
  adminStatus: InputAdminStatus
  applianceType: ApplianceType
}

const RtmpForm = ({ form, addresses, namePrefix, occupiedPorts, adminStatus, applianceType }: RtmpFormProps) => {
  const addressSelector = `${namePrefix}.${RtmpFields.address}`
  return (
    <>
      <Select
        name={addressSelector}
        label="Address"
        required
        options={makeAddressOptions(get(form.values, addressSelector), addresses)}
        newLine
        validators={{
          addressIn: { addresses },
        }}
      />
      <SuggestedLocalPortTextField
        name={`${namePrefix}.${RtmpFields.port}`}
        label={'Port'}
        namePrefix={namePrefix}
        required={true}
        portInfo={{
          mode: IpPortMode.rtmp,
          isInput: true,
          existingLogicalPortsOnSameNic: occupiedPorts,
          isPortDisabled: adminStatus === InputAdminStatus.off,
        }}
      />

      {!isVaApplianceType(applianceType) && (
        <WhitelistCidrBlockAutoComplete
          name={`${namePrefix}.${RtmpFields.whitelistCidrBlock}`}
          required={isCoreNode(applianceType)}
        />
      )}
    </>
  )
}

export default RtmpForm
